// @flow
import {
  SET_RESELLER_TREE,
  UPDATE_PROJECT_LIST,
  GET_CLOSESTATUS_LIST,
  PROJECT_ENDUSER_LIST,
  GET_PROJECT_LIST,
  SET_DISTRIBUTER_TREE
} from "../../global/actions/actionNames";

const initialState = {
  resellerTree: null,
  projects: null,
  closeStatuses: null,
  endusers: null,
  distributerTree: null
};

const projectReducers = (state: * = initialState, actions: *): * => {
  switch (actions.type) {
    case SET_RESELLER_TREE:
      if (actions.resellers !== null) {
        return {
          ...state,
          resellerTree: [...actions.resellers]
        };
      }
      return state;

    case SET_DISTRIBUTER_TREE:
      if (actions.distributers !== null) {
        return {
          ...state,
          distributerTree: [...actions.distributers]
        };
      }
      return state;

    case GET_PROJECT_LIST:
      if (actions.projects !== null) {
        return {
          ...state,
          projects: [...actions.projects]
        };
      }
      return state;

    case UPDATE_PROJECT_LIST:
      let projects = state.projects === null ? [] : [...state.projects];
      if (actions.project !== null && actions.project.id !== null) {
        if (projects.length > 0) {
          let index = projects.findIndex(x => x.id === actions.project.id);
          if (index > -1) {
            projects[index] = actions.project;
          } else {
            projects.push(actions.project);
          }
        } else {
          projects.push(actions.project);
        }
      }
      return {
        ...state,
        projects: projects
      };

    case GET_CLOSESTATUS_LIST:
      if (actions.closeStatuses !== null) {
        const closeStatuses = actions.closeStatuses;
        return {
          ...state,
          closeStatuses: closeStatuses
        };
      }
      return state;

    case PROJECT_ENDUSER_LIST:
      if (actions.endusers !== null) {
        const endusers = [...actions.endusers];
        return {
          ...state,
          endusers: endusers
        };
      }
      return state;

    default:
      return state;
  }
};
export default projectReducers;
